import React from "react";

import dayjs from "dayjs";

import { graphql, useStaticQuery } from "gatsby";

import styled from "@emotion/styled";

import Carousel from "../../Carousel";
import { contentContainer } from "../../ContentContainer";
import ItemCard from "../../ItemCard";
import LinkComponent from "../../LinkComponent";
import NewHeadline from "../../NewHeadline";

const Container = styled.div`
    ${contentContainer}
    ${({ theme }) => theme.breakpoints.upTo.small.css`
        padding: 0 30px;
    `}

    ${({ theme }) => theme.breakpoints.upTo.extraSmall.css`
        padding: 0 20px;
    `}
`;

const itemWidth = 260;

const Item = styled(Carousel.Item)`
    width: ${itemWidth}px;
`;

const LinkRow = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

const Blogs = ({ name, linkText, allEntriesLinkText }) => {
    let blogs = {
        nodes: [
            {
                slug: "test-1",
                title: "Test 1",
                datePublished: dayjs(),
            },
            {
                slug: "test-2",
                title: "Test 2",
                datePublished: dayjs(),
            },
            {
                slug: "test-3",
                title: "Test 3",
                datePublished: dayjs(),
            },
            {
                slug: "test-4",
                title: "Test 4",
                datePublished: dayjs(),
            },
        ],
    };
    try {
        const data = useStaticQuery(graphql`
            query {
                blogs: allBlogsYaml(
                    sort: { fields: datePublished, order: DESC }
                    limit: 4
                ) {
                    nodes {
                        slug
                        id
                        articleBody
                        abstract
                        dateCreated
                        dateModified
                        datePublished
                        disabled
                        section
                        title
                        yamlId
                        video {
                            url
                            thumbnail {
                                alt
                                imageObject {
                                    caption
                                    description
                                }
                                src {
                                    ...ImageSrc
                                    childImageSharp {
                                        gatsbyImageData(
                                            layout: FULL_WIDTH

                                            placeholder: BLURRED
                                        )
                                    }
                                }
                                title
                            }
                        }
                        image {
                            alt
                            imageObject {
                                caption
                                description
                            }
                            src {
                                ...ImageSrc
                                childImageSharp {
                                    gatsbyImageData(
                                        layout: FULL_WIDTH

                                        placeholder: BLURRED
                                    )
                                }
                            }
                            title
                        }
                    }
                }
            }
        `);
        blogs = data.blogs;
    } catch (error) {
        console.log(error);
    }

    return (
        <Container>
            <NewHeadline color="blue">{name}</NewHeadline>
            <Carousel>
                {blogs.nodes.map((blog, i) => (
                    <Item key={i}>
                        <ItemCard
                            item={blog}
                            linkText={linkText}
                            width={itemWidth}
                        />
                    </Item>
                ))}
            </Carousel>

            <LinkRow>
                <LinkComponent
                    link={{ href: "/blog", text: allEntriesLinkText }}
                    icon="arrow-right"
                    color="blue"
                />
            </LinkRow>
        </Container>
    );
};

export default Blogs;
